<template>
    <v-card
        class="soli-round"
        @click="$inertia.visit(route('help-articles.show', card.id))"
    >
        <v-card-title class="primary--text"> {{ card.title }} </v-card-title>
        <v-card-subtitle :title="card.updated_at"
            >Last updated {{ card.updated_at_display }}</v-card-subtitle
        >
        <v-card-text>{{ card.excerpt }}</v-card-text>
    </v-card>
</template>

<script>
import { Link } from "@inertiajs/vue2";
export default {
    props: {
        card: Object,
    },
    components: {
        Link,
    },
};
</script>
